import React, { PropsWithChildren, useMemo } from "react";
import cx from "classnames";

import styles from "./index.module.scss";

interface Props {
  className?: string;
  winHeight?: number;
  scrollTop?: number;
  height?: number;
  dataAry?: any[];
}

const XtScrollUl = React.forwardRef<HTMLDivElement, PropsWithChildren<Props>>(
  ({ children, className, winHeight = 0, scrollTop = 0, height = 30, dataAry = [], ...rest }, ref) => {
    const totalHeight = useMemo(() => height * dataAry.length, [height, dataAry]);
    const startIndex = useMemo(() => Math.max(Math.floor(scrollTop / height) - 1, 0), [scrollTop, height]);
    const start = useMemo(() => startIndex * height, [startIndex, height]);
    const count = useMemo(() => {
      const nextCount = Math.ceil((scrollTop - start + winHeight + height) / height);
      return Math.min(nextCount, dataAry.length);
    }, [scrollTop, start, winHeight, height, dataAry]);
    const record = useMemo(() => dataAry.slice(startIndex, startIndex + count), [dataAry, startIndex, count]);

    const childrenWithProps = React.Children.map(children, (child) => {
      if (!React.isValidElement(child)) return null;
      return React.cloneElement(child, { ...child.props, startIndex, record });
    });

    return (
      <div ref={ref} className={cx(styles.main, className)} style={{ height: totalHeight + "px" }} {...rest}>
        {childrenWithProps}
      </div>
    );
  }
);

XtScrollUl.displayName = "XtScrollUl";

export default XtScrollUl;
